import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import Badge from '@material-ui/core/Badge'
import IconButton from '@material-ui/core/IconButton'
import NotificationsIcon from '@material-ui/icons/Notifications'
import LinearProgress from '@material-ui/core/LinearProgress'
import Popover from '@material-ui/core/Popover'
import List from '@material-ui/core/List'
import { localized } from 'decorators'
import { actionCreators } from 'store/modules/backgroundActions'
import ListSubheader from '@material-ui/core/ListSubheader'
import { BackgroundActionItem } from './item'
import { useStyles } from './index.css'

export const BackgroundActionsButton = connect(
  ({ backgroundActions }) => ({ backgroundActions }),
  { get: actionCreators.get }
)(localized(({ localize, backgroundActions, get }) => {
  useEffect(() => { get() }, [backgroundActions.gridKey, get])
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleClick = React.useCallback((e) => {
    setAnchorEl(e.currentTarget)
  }, [setAnchorEl])
  const handleClose = React.useCallback((e) => {
    setAnchorEl(null)
  }, [setAnchorEl])

  const { entity } = backgroundActions
  const items = (entity || [])
  const hasActions = items.length > 0

  return (
    <React.Fragment>
      <div className={classes.root}>
        <IconButton color='inherit' onClick={handleClick}>
          <Badge badgeContent={items.length} color='secondary'>
            <NotificationsIcon />
          </Badge>
        </IconButton>
        {hasActions && <LinearProgress variant='indeterminate' className={classes.progress} />}

      </div>
      <Popover
        id='notification-popover'
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <List className={classes.listRoot} subheader={<ListSubheader className={classes.header} color='primary' component='div'>{localize('notifications.title')}</ListSubheader>}>
          {hasActions && items.map((item, index) => <BackgroundActionItem className={classes.item} key={index} backgroundAction={item} />)}
          {!hasActions && <BackgroundActionItem />}

        </List>
      </Popover>

    </React.Fragment>
  )
}))
